import React from 'react';
import { Truck, Gift } from 'lucide-react';

const FreeShippingBar = ({ cartTotal, threshold = 50 }) => {
  const progress = Math.min((cartTotal / threshold) * 100, 100);
  const remaining = Math.max(threshold - cartTotal, 0);
  const qualified = cartTotal >= threshold;

  return (
    <div className="bg-gradient-to-r from-teal-50 to-emerald-50 dark:from-teal-900/20 dark:to-emerald-900/20 rounded-xl p-4 mb-4">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          {qualified ? (
            <Gift className="w-5 h-5 text-emerald-600" />
          ) : (
            <Truck className="w-5 h-5 text-teal-600" />
          )}
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
            {qualified ? (
              <span className="text-emerald-600 dark:text-emerald-400">
                🎉 You've unlocked FREE shipping!
              </span>
            ) : (
              <>
                Add <span className="font-bold text-teal-600">${remaining.toFixed(2)}</span> more for FREE shipping
              </>
            )}
          </span>
        </div>
        <span className="text-xs text-gray-500">${cartTotal.toFixed(2)} / ${threshold}</span>
      </div>
      
      {/* Progress Bar */}
      <div className="h-2 bg-gray-200 dark:bg-gray-700 rounded-full overflow-hidden">
        <div
          className={`h-full rounded-full transition-all duration-500 ${
            qualified
              ? 'bg-gradient-to-r from-emerald-500 to-green-500'
              : 'bg-gradient-to-r from-teal-500 to-cyan-500'
          }`}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default FreeShippingBar;
